import type { DatabaseConnectionMode } from '../types'

export type { DatabaseConnectionMode }

export type EffectiveConnectionMode = DatabaseConnectionMode

/** Prefer API `connectionMode`; fall back to legacy `hosted` boolean. */
export function getEffectiveConnectionMode(db: {
  connectionMode?: string | null
  hosted?: boolean | null
}): EffectiveConnectionMode {
  if (
    db.connectionMode === 'self_hosted' ||
    db.connectionMode === 'cloud' ||
    db.connectionMode === 'synthetic'
  ) {
    return db.connectionMode
  }
  if (db.hosted === false) return 'self_hosted'
  return 'cloud'
}

export function connectionModeLabel(mode: EffectiveConnectionMode): string {
  if (mode === 'self_hosted') return 'Self-hosted proxy'
  if (mode === 'synthetic') return 'Synthetic'
  return 'VeilStream proxy'
}

export function connectionModeShortDescription(mode: EffectiveConnectionMode): string {
  if (mode === 'self_hosted') {
    return 'You run the proxy; upstream URI stays in your network.'
  }
  if (mode === 'synthetic') {
    return 'Schema-only source with on-the-fly fake data for previews; snapshots materialize seeds for forks.'
  }
  return 'VeilStream hosts a proxy that filters data. You provide a reachable Postgres URI.'
}

/** Query/path param for the connect wizard (`cloud` | `self_hosted`). */
export function parseConnectConnectionMode(
  raw: string | null | undefined,
): Extract<DatabaseConnectionMode, 'cloud' | 'self_hosted'> {
  if (raw === 'self_hosted') return 'self_hosted'
  return 'cloud'
}

/** True when VeilStream already has a managed proxy path to this database (URI was configured). */
export function databaseHasManagedConnection(db: {
  connectionMode?: string | null
  hosted?: boolean | null
  hostedProxy?: unknown
}): boolean {
  return Boolean(db.hostedProxy)
}
